import { ErrorHandler, NgModule, isDevMode } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

// APP
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {
	GlobalErrorHandler,
	RequestInterceptor
} from './global/request.interceptor';
//
import { UnknownRouteComponent } from './view-routes/unknown-route/unknown-route.component';
import { CoreModule } from './view-shared/core.module';
import { Constants } from './global/constants';
import { GlobalService } from './global/global.service';
import { AuthGuard } from './global/auth.guard';
import { ServiceWorkerModule } from '@angular/service-worker';

@NgModule({
	// The set of components, directives, and pipes (declarables) that belong to this module.
	declarations: [AppComponent, UnknownRouteComponent],
	// The set of NgModules whose exported declarables are available to templates in this module.
	imports: [
		BrowserModule,
		BrowserAnimationsModule,
		AppRoutingModule,
		HttpClientModule,
		RouterModule,
		TranslateModule.forRoot(
			Constants.createTranslateModuleConfig('./assets/i18n/')
		),
		CoreModule,
		ServiceWorkerModule.register('ngsw-worker.js', {
			enabled: !isDevMode(),
			registrationStrategy: 'registerImmediately' // or 'registerWhenStable:30000'
		})
	],
	// The set of injectable objects that are available in the injector of this module.
	providers: [
		AuthGuard,
		{ provide: HTTP_INTERCEPTORS, useClass: RequestInterceptor, multi: true },
		{ provide: ErrorHandler, useClass: GlobalErrorHandler }
	],
	// The set of components that are bootstrapped when this module is bootstrapped. The components listed here are automatically added to entryComponents.
	bootstrap: [AppComponent]
})
export class AppModule {
	constructor(translateService: TranslateService, globalService: GlobalService) {
		let lang: any = localStorage['language']
			? localStorage['language']
			: window.navigator.language;
		lang = lang.split('-');
		lang = lang[0];

		globalService.userStore.$appLanguage.subscribe(val => {
			const currentLang = val;
			translateService.currentLang = '';
			translateService.use(currentLang);
		});
		globalService.setLanguage(lang);
	}
}
